import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from "@angular/material/dialog";
import {SF, TD} from "../../helpers/distance";
import {MessageDialogService} from "../../services/message-dialog.service";
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-wheel-selector-set-value-dialog',
    templateUrl: './wheel-selector-set-value-dialog.component.html',
    styleUrls: ['./wheel-selector-set-value-dialog.component.scss'],
    imports: [MatButton, MatIcon, MatDialogActions, TranslocoModule]
})
export class WheelSelectorSetValueDialogComponent {
  dialogRef = inject<MatDialogRef<WheelSelectorSetValueDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  value = ''
  messageDialog = inject(MessageDialogService)

  btn(nb: string) {
    this.value += nb
  }

  btnPlusMoins() {
    if (this.isNombreNegatif()) {
      this.mettrePositif();
    } else {
      this.mettreNegatif();
    }
  }

  private isNombreNegatif(): boolean {
    const premierCar = this.value[0] || ''
    return premierCar === '-'
  }

  private mettreNegatif() {
    if (!this.isNombreNegatif()) {
      this.value = '-' + this.value
    }
  }

  private mettrePositif() {
    if (this.isNombreNegatif()) {
      this.value = this.value.substring(1)
    }
  }

  btnEffacer() {
    this.value = this.value.substring(0, this.value.length - 1)
  }

  safety() {
    this.value = SF
    this.ok()
  }

  td() {
    this.value = TD
    this.ok()
  }

  btnHome() {
    if (this.data.homeHasPossession) {
      this.mettreNegatif()
    } else {
      this.mettrePositif()
    }
  }

  btnAway() {
    if (this.data.homeHasPossession) {
      this.mettrePositif()
    } else {
      this.mettreNegatif()
    }
  }

  onKeyPress(event: KeyboardEvent) {
    const map: any = {
      '1': () => this.btn('1'),
      '2': () => this.btn('2'),
      '3': () => this.btn('3'),
      '4': () => this.btn('4'),
      '5': () => this.btn('5'),
      '6': () => this.btn('6'),
      '7': () => this.btn('7'),
      '8': () => this.btn('8'),
      '9': () => this.btn('9'),
      '0': () => this.btn('0'),
      '-': () => this.btnPlusMoins(),
      '+': () => this.btnPlusMoins(),

      'Enter': () => this.ok(),
      'Escape': () => this.cancel(),
      'Backspace': () => this.btnEffacer(),
    }

    const fn = map[event.key]
    if (fn) {
      fn()
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  ok() {
    if (!this.isValid()) {
      this.messageDialog.openMessage(
        'validation.warningTitle',
        'validation.invalidNumber',
        'validation.continue',
        'warning'
      );
      return
    }

    this.dialogRef.close({
      value: this.value
    });
  }

  isValid(): boolean {
    const nombre = Number.parseInt(this.value);

    if (this.data.gain) {
      return this.isGainValid(nombre)
    } else {
      return this.isSpotValid(nombre)
    }
  }

  isSpotValid(nombre: number): boolean {
    if (nombre > 55) return false
    if (nombre < -54) return false

    return true
  }

  // 1 - 111
  // 0 - -110
  isGainValid(nombre: number): boolean {
    if (nombre > 111) return false
    if (nombre < -110) return false

    return true
  }
}
